import { render, staticRenderFns } from "./StockTransactionAuditPage.vue?vue&type=template&id=683d7e82"
import script from "./StockTransactionAuditPage.vue?vue&type=script&lang=js"
export * from "./StockTransactionAuditPage.vue?vue&type=script&lang=js"
import style0 from "./StockTransactionAuditPage.vue?vue&type=style&index=0&id=683d7e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports